/* eslint-disable @typescript-eslint/no-explicit-any */
import { fork, put, takeLatest } from 'redux-saga/effects';
import { getType } from '../../utils';
import actions from './actions';
export function* loadUserApps(api, action) {
    try {
        const { data } = yield api
            .getUserApps({
            userId: action.payload.userId,
            clientId: action.payload.clientId,
        })
            .then((p) => p.request);
        yield put(actions.loadUserAppsSuccess(data));
    }
    catch (error) {
        yield put(actions.loadUserAppsError(error));
    }
}
export function* pullUserApps(api, action) {
    try {
        const { userId, appName, startAt, clientId } = action.payload;
        yield api
            .pullAppsByUserId({
            userId,
            appName,
            startAt,
            clientId,
        })
            .then((p) => p.request);
        yield put(actions.pullUserAppsSuccess());
    }
    catch (error) {
        yield put(actions.pullUserAppsError(error));
    }
}
export function* deleteUserApp(api, action) {
    try {
        const { userId, appName } = action.payload;
        yield api
            .deleteUserApp({ userId, appName })
            .then((p) => p.request);
        yield put(actions.deleteUserAppSuccess(appName));
    }
    catch (error) {
        yield put(actions.deleteUserAppError(error));
    }
}
export function* watchLoadUserApps(api) {
    yield takeLatest(getType(actions.loadUserApps), loadUserApps, api);
}
export function* watchPullUserApps(api) {
    yield takeLatest(getType(actions.pullUserApps), pullUserApps, api);
}
export function* watchDeletUserApp(api) {
    yield takeLatest(getType(actions.deleteUserApp), deleteUserApp, api);
}
export const appsSagas = (api) => [
    fork(watchLoadUserApps, api),
    fork(watchPullUserApps, api),
    fork(watchDeletUserApp, api),
];
export default appsSagas;
